import ApiProfile from '@/services/ApiProfile';
import Vue from 'vue';
import router from '@/routers';

export default {
    namespaced: true,
    state: {
        accountState: {
            created: false,
            edited: false,
            passEdited: false,
            deleted: false,
            detail: null,
            list: []
        }
    },
    getters: {},
    mutations: {
        show(state, payload) {
            state.accountState[payload.state] = !state.accountState[payload.state];
        },

        store(state, payload) {
            state.accountState[payload.state] = payload.data.data;
        }
    },
    actions: {
        async listAccount({ commit }, req) {
            try {
                const res = await ApiProfile.listAccount(req);
                res.state = 'list';
                commit('store', res);
                return res;
            } catch (error) {
                Vue.notify({
                    group: 'notif',
                    type: 'error',
                    title: 'Error',
                    text: error.response ?
                        error.response.data.message :
                        'There is something wrong'
                });
                throw error;
            }
        },

        async detailAccount({ commit }, req) {
            try {
                commit('StoreLoading/showLoading', '', { root: true });
                const res = await ApiProfile.detailAccount(req);
                res.state = 'detail';
                commit('store', res);
                commit('StoreLoading/hideLoading', '', { root: true });
                return res;
            } catch (error) {
                commit('StoreLoading/hideLoading', '', { root: true });
                Vue.notify({
                    group: 'notif',
                    type: 'error',
                    title: 'Error',
                    text: error.response ?
                        error.response.data.message :
                        'There is something wrong'
                });
                throw error;
            }
        },

        async createAccount({ commit }, req) {
            try {
                commit('StoreLoading/showLoading', '', { root: true });
                const res = await ApiProfile.createAccount(req);
                res.state = 'created';
                commit('show', res);
                Vue.notify({
                    group: 'notif',
                    type: 'success',
                    title: 'Success',
                    text: res.data.message
                });
                router.replace('/home/account');
                commit('StoreLoading/hideLoading', '', { root: true });
            } catch (error) {
                commit('StoreLoading/hideLoading', '', { root: true });
                Vue.notify({
                    group: 'notif',
                    type: 'error',
                    title: 'Error',
                    text: error.response ?
                        error.response.data.message :
                        'There is something wrong'
                });
                throw error;
            }
        },

        async editAccount({ commit }, req) {
            try {
                commit('StoreLoading/showLoading', '', { root: true });
                const res = await ApiProfile.editAccount(req);
                res.state = 'edited';
                commit('show', res);
                Vue.notify({
                    group: 'notif',
                    type: 'success',
                    title: 'Success',
                    text: res.data.message
                });
                router.replace('/home/account');
                commit('StoreLoading/hideLoading', '', { root: true });
            } catch (error) {
                commit('StoreLoading/hideLoading', '', { root: true });
                Vue.notify({
                    group: 'notif',
                    type: 'error',
                    title: 'Error',
                    text: error.response ?
                        error.response.data.message :
                        'There is something wrong'
                });
                throw error;
            }
        },

        async editAccountPassword({ commit }, req) {
            try {
                commit('StoreLoading/showLoading', '', { root: true });
                const res = await ApiProfile.editAccountPassword(req);
                res.state = 'passEdited';
                commit('show', res);
                Vue.notify({
                    group: 'notif',
                    type: 'success',
                    title: 'Success',
                    text: res.data.message
                });
                router.replace('/home/account');
                commit('StoreLoading/hideLoading', '', { root: true });
            } catch (error) {
                commit('StoreLoading/hideLoading', '', { root: true });
                Vue.notify({
                    group: 'notif',
                    type: 'error',
                    title: 'Error',
                    text: error.response ?
                        error.response.data.message :
                        'There is something wrong'
                });
                throw error;
            }
        },

        async deleteAccount({ commit }, req) {
            try {
                commit('StoreLoading/showLoading', '', { root: true });
                const res = await ApiProfile.deleteAccount(req);
                res.state = 'deleted';
                commit('show', res);
                Vue.notify({
                    group: 'notif',
                    type: 'success',
                    title: 'Success',
                    text: res.data.message
                });
                commit('StoreLoading/hideLoading', '', { root: true });
            } catch (error) {
                commit('StoreLoading/hideLoading', '', { root: true });
                Vue.notify({
                    group: 'notif',
                    type: 'error',
                    title: 'Error',
                    text: error.response ?
                        error.response.data.message :
                        'There is something wrong'
                });
                throw error;
            }
        }
    }
};